// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-waterproof-large-capacity-motorcycle-backpack-helmet-holder",
  "entries": [
    {
      "id": "24009134768318",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/mochila_porta_casco_de_seguridad.jpg?v=1763365457",
      "alt": "bag for riding motorcycle"
    },
    {
      "id": "31006670946494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-31006670946494.png?v=1769482967",
      "alt": "funny motorcycle backpack"
    },
    {
      "id": "28666987020478",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666987020478.jpg?v=1769482973",
      "alt": "mochila porta casco de seguridad"
    },
    {
      "id": "28666987118782",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666987118782.jpg?v=1769482974",
      "alt": "Waterproof Large Capacity Motorcycle Backpack "
    },
    {
      "id": "28666986954942",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986954942.jpg?v=1769482974",
      "alt": "Motorcycle Backpack "
    },
    {
      "id": "28666986922174",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986922174.jpg?v=1769482974",
      "alt": "helmet holder honda cg"
    },
    {
      "id": "28666987086014",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666987086014.jpg?v=1769482974",
      "alt": "big motorcycle backpack"
    },
    {
      "id": "28666987151550",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666987151550.jpg?v=1769482974",
      "alt": "big motorcycle backpack"
    },
    {
      "id": "28666986856638",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986856638.jpg?v=1769482974",
      "alt": "bmw motorcycle backpack"
    },
    {
      "id": "24115915751614",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-24115915751614.jpg?v=1769482974",
      "alt": "waterproof hunting backpack"
    },
    {
      "id": "31006682087614",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-31006682087614.png?v=1769482974",
      "alt": "waterproof bag for backpack"
    },
    {
      "id": "28666986791102",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986791102.jpg?v=1769482974",
      "alt": "earth pak summit dry bag backpack"
    },
    {
      "id": "28666986823870",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986823870.jpg?v=1769482974",
      "alt": "waterproof backpack with water bottle holder"
    },
    {
      "id": "28666986758334",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986758334.jpg?v=1769482974",
      "alt": "functional backpack"
    },
    {
      "id": "28666986725566",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986725566.jpg?v=1769482974",
      "alt": "der rucksack"
    },
    {
      "id": "28666986692798",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-28666986692798.jpg?v=1769482974",
      "alt": "rucksack helm"
    },
    {
      "id": "24135499350206",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-24135499350206.jpg?v=1769482974",
      "alt": "Seibertron Waterproof Large Capacity Motorcycle Backpack Helmet Holder - SeibertronAutomotive Parts and Accessories"
    },
    {
      "id": "24135495778494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-24135495778494.jpg?v=1769482985",
      "alt": "Seibertron Waterproof Large Capacity Motorcycle Backpack Helmet Holder - SeibertronAutomotive Parts and Accessories"
    },
    {
      "id": "24135496302782",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Waterproof-Large-Capacity-Motorcycle-Backpack-Helmet-Holder-Seibertron-24135496302782.jpg?v=1769482985",
      "alt": "Seibertron Waterproof Large Capacity Motorcycle Backpack Helmet Holder"
    }
  ],
  "variants": [
    {
      "id": "41897936584894",
      "title": "main backpack Black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "main backpack Black"
        }
      ],
      "values": [
        "main backpack Black"
      ],
      "mediaId": "24009134768318"
    },
    {
      "id": "41897936617662",
      "title": "main backpack Khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "main backpack Khaki"
        }
      ],
      "values": [
        "main backpack Khaki"
      ],
      "mediaId": "31006682087614"
    },
    {
      "id": "41974943809726",
      "title": "2 pieces of sissy bar straps black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "2 pieces of sissy bar straps black"
        }
      ],
      "values": [
        "2 pieces of sissy bar straps black"
      ],
      "mediaId": "24135495778494"
    },
    {
      "id": "41974943842494",
      "title": "2 pieces of sissy bar straps khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "2 pieces of sissy bar straps khaki"
        }
      ],
      "values": [
        "2 pieces of sissy bar straps khaki"
      ],
      "mediaId": "24135496302782"
    },
    {
      "id": "41974960816318",
      "title": "2L water bladder",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "2L water bladder"
        }
      ],
      "values": [
        "2L water bladder"
      ],
      "mediaId": "24135499350206"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false,
  "forceExactColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function syncApprovedDescriptionCopy(scope) {
    if (config.handle !== 'seibertron-motorbike-backpack-motorcycle-bag-outdoor-sports-riding-package') return;
    var oldOpening = 'Ultimate Water-Resistant Backpack: Built with durable 900D waterproof fabric, this backpack is designed for riders and outdoor users who need dependable everyday protection from light rain and road spray.';
    var oldNote = 'Water-Resistance Note: The 900D fabric is waterproof, but the complete backpack is water resistant rather than fully waterproof because zippers and stitch openings can allow moisture through. Always close the backpack securely to help keep gear dry.';
    var oldHighlight = '900D waterproof fabric and water-resistant backpack construction help protect gear in everyday conditions.';
    Array.prototype.slice.call(scope.querySelectorAll('p')).forEach(function (paragraph) {
      var text = String(paragraph.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === oldOpening) {
        paragraph.innerHTML = '<strong>Introducing the Ultimate Water Resistant Backpack!</strong> Made from durable 900D water resistant material, this backpack is perfect for outdoor enthusiasts who need reliable protection from the elements ...';
      } else if (text === oldNote) {
        paragraph.innerHTML = '<strong>Water Resistance Note:</strong> The backpack uses water resistant 900D material and construction for everyday protection. Moisture can still pass through zippers and stitch openings, so it is not designed for submersion. Always close the backpack securely to help keep gear dry.';
      }
    });
    Array.prototype.slice.call(scope.querySelectorAll('li')).forEach(function (item) {
      var text = String(item.textContent || '').replace(/\s+/g, ' ').trim();
      var replacement = {
        '37L capacity organizes riding gear, outdoor equipment, and daily essentials.': '900D coated fabric, durable SBS zippers, and secure KAM buckles provide water-resistant, abrasion-resistant construction for demanding daily use.',
        'Durable 900D water resistant material and backpack construction help protect gear in everyday conditions.': 'MOLLE webbing, shoulder-strap D-rings, bottom straps, and a top carry handle expand options for small gear, a water bottle, a sleeping pad, or a sleeping bag.',
        '900D waterproof fabric and water-resistant backpack construction help protect gear in everyday conditions.': 'MOLLE webbing, shoulder-strap D-rings, bottom straps, and a top carry handle expand options for small gear, a water bottle, a sleeping pad, or a sleeping bag.',
        'MOLLE webbing plus adjustable chest and waist straps support organized, secure carry.': 'A load-supporting, heat-dissipating back system, adjustable chest strap (up to 60 in), and hydration-hose keeper support comfortable carry; the rescue whistle can help attract attention in an emergency.'
      }[text];
      if (replacement) item.textContent = replacement;
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      if (config.forceExactColorSwatches && optionName === 'Color') {
        var shell = choice.querySelector('[data-auto-choice-label]') || choice;
        var expectedSrc = sized(entry.src, 180);
        var existingImage = shell.querySelector('img');
        if (!(existingImage && existingImage.src === expectedSrc && existingImage.alt === input.value)) {
          shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(input.value || entry.alt || '') + '"><img src="' + escapeHtml(expectedSrc) + '" alt="' + escapeHtml(input.value || entry.alt || '') + '" width="72" height="72" loading="eager"></span><span class="auto-product__swatch-label">' + escapeHtml(input.value || '') + '</span>';
        }
        choice.setAttribute('data-variant-media-id', entry.id);
        choice.setAttribute('data-falcon-full-gallery-swatch-media-id', entry.id);
        return;
      }
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var isDesired = config.entries.some(function (entry) { return entry.id === thumb.getAttribute('data-media-id'); });
      thumb.hidden = !isDesired;
      thumb.style.display = isDesired ? '' : 'none';
      thumb.setAttribute('aria-hidden', isDesired ? 'false' : 'true');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncApprovedDescriptionCopy(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) {
        return record.type === 'attributes' || record.addedNodes.length || record.removedNodes.length;
      });
      if (changed) window.setTimeout(hydrate, 0);
    });
    observer.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-safe-gallery-media-ids', 'src', 'srcset', 'data-variant-media-id']
    });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
